import classNames from 'clsx';
import React from 'react';
import { useParams } from 'react-router';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import { RoutingKey } from '@swf/core/enums';
import { ClubRoute } from '@swf/core/types/Poker';

import CogIcon from '../assets/cog.svg';

import styles from './SettingsButton.scss';

const SettingsButton: React.FC = () => {
  const { clubId, section } = useParams<{ clubId: string; section?: string }>();

  return (
    <StarsButton
      data-testid="settings-button"
      variant="text"
      className={classNames(styles.button, { [styles.active]: section === ClubRoute.Settings })}
      icon={<CogIcon className={styles.icon} />}
      route={RoutingKey.HomeGamesClubs}
      routeValues={{ clubId, section: ClubRoute.Settings }}
    />
  );
};

export default SettingsButton;
